<script setup lang="ts">
import { computed } from 'vue';

import StandardPage from '@/content-types/standard-page/StandardPage.vue';
import { type NuxtError, useSeoMeta } from '#app';

const props = defineProps<{
  error: NuxtError;
}>();

const errorTitle = computed(() => {
  switch (props.error.statusCode) {
    case 404:
      return 'Not found';

    default:
      return 'Error';
  }
});

useSeoMeta({
  title: `${errorTitle.value} | Open Methane`,
  ogTitle: `${errorTitle.value} | Open Methane`,
});
</script>

<template>
  <StandardPage>
    <main class="main">
      <h1 class="title">
        {{ errorTitle }}
      </h1>
      <p v-if="error.statusCode === 404">
        Sorry, there's nothing here.
      </p>
      <p v-else>
        An unknown error occurred: {{ error.statusMessage }}
      </p>
    </main>
  </StandardPage>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/shared/screen' as screen;

.main {
  max-width: 64rem;
  min-height: 40vh;
  margin: var(--spacing-l) auto;

  @include screen.respond(tablet) {
    margin-left: var(--spacing-m);
    margin-right: var(--spacing-m);
  }
}
</style>
